import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tabbar" }
const _hoisted_2 = {
  key: 0,
  class: "center-img-wrap"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "tabbar-item"
}

import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useHelpTool } from '@/hooks'
import { useReddotStore } from "@/store";


export default {
  __name: 'TabbarLayout',
  setup(__props) {

const { t } = useI18n()
const { doShare } = useHelpTool();

const redDotStore = useReddotStore();
const { inviteFriendEnergy } = storeToRefs(redDotStore);

const appPageInfoList = ref([]); 

onMounted(() => {
  appPageInfoList.value = [
    { tab: 0, title: t('tabbar.share'), code: 'share', onClick: doShare },
    { tab: 1, title: t('tabbar.home'), code: 'home', to: '/game' },
    { tab: 2, title: t('tabbar.inviteFriends'), code: 'invite', to: '/energy', isCenter: true },
    { tab: 3, title: t('tabbar.events'), code: 'event', to: '/event' },
    { tab: 4, title: t('tabbar.helpSlot'), code: 'help-slot', to: '/helpSlot' },
  ]
})

const onTabClick = (tab) => {
  if (tab.onClick) {
    tab.onClick();
  }
};

return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")
  const _component_van_badge = _resolveComponent("van-badge")
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")
  const _component_van_tabbar = _resolveComponent("van-tabbar")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, {
      class: "main-page",
      ref: "subView"
    }, null, 512),
    _createVNode(_component_van_tabbar, {
      route: "",
      "active-color": "#00FF38",
      border: false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appPageInfoList.value, (tab, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_van_tabbar_item, {
            key: tab.tab,
            to: tab.to,
            badge: tab.badge  || null,
            class: _normalizeClass({ 'isCenter': tab.isCenter }),
            onClick: $event => (onTabClick(tab))
          }, {
            icon: _withCtx((props) => [
              (tab.code)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (tab.isCenter)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_van_badge, {
                            content: _unref(inviteFriendEnergy) || null
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                class: "center-img",
                                src: require(`@/assets/img/tabbar/${tab.code}.png`)
                              }, null, 8, _hoisted_3)
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_van_image, {
                            class: "tabbar-icon",
                            src: require(`@/assets/img/tabbar/${tab.code}.png`),
                            fit: "contain"
                          }, null, 8, ["src"])
                        ]))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(tab.title.toUpperCase()), 1)
            ]),
            _: 2
          }, 1032, ["to", "badge", "class", "onClick"])), [
            [_directive_audio]
          ])
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

}